import MenuSmartSegmentation from "../MenuSmartSegmentation";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuIniciRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PesquisaArtigo from "../PesquisaArtigo";

export default function HowSegmentaçãoClientes() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/smart-segmentation">Smart Segmentation</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Como criar uma Segmentação de Clientes?
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuSmartSegmentation />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                Como criar uma Segmentação de Clientes?
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Smart Segmentation</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Segmentação de dados
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  Na página inicial clique em "Segmentação de clientes" ou no
                  menu superior clique em "Planejar" e em seguida em
                  "Segmentação de contato":
                </p>

                <figure>
                  <img src="img/segmentcontact.png" alt="excel" />
                </figure>

                <figcaption>Segmentação de Contato</figcaption>

                <p>
                  O sistema permite efetuar a <a> </a>
                  <a href="/o-que-e-a-segmentacao-de-clientes" target="blank">
                    segmentação de clientes
                  </a>{" "}
                  por meio de todas as bases importadas ou por meio de algum
                  arquivo específico.
                </p>

                <p>
                  A segmentação de dados consiste em dividir um conjunto de
                  informações em grupos específicos com base em certos
                  critérios. Por isso existe no sistema as condicionais 'E' e
                  'OU'. para definir os parâmetros de segmentação. Vamos
                  explorar essas condicionais e como elas funcionam na
                  segmentação de dados:
                </p>

                <p>Condicional "E" (AND):</p>

                <p>
                  A condicional "E" é usada para segmentar dados com base em
                  múltiplos critérios que devem ser atendidos simultaneamente
                  para que um registro seja incluído no grupo. Por exemplo, em
                  uma base de dados de clientes, você pode usar a condicional
                  "E" da seguinte maneira:
                </p>

                <p>
                  Segmente todos os clientes que são do sexo masculino E têm
                  mais de 30 anos.
                </p>

                <p>
                  Nesse caso, apenas os clientes que atendem a ambos os
                  critérios (sexo masculino E idade superior a 30 anos) seriam
                  incluídos na segmentação.
                </p>

                <p>Condicional "OU" (OR):</p>

                <p>
                  A condicional "OU" é usada para segmentar dados com base em
                  critérios múltiplos, mas ao contrário da condicional "E",
                  apenas um dos critérios precisa ser atendido para que um
                  registro seja incluído no grupo. Por exemplo:
                </p>

                <p>
                  Segmente todos os clientes que são do sexo feminino OU têm
                  feito compras nos últimos 6 meses.
                </p>

                <p>
                  Neste caso, qualquer cliente que atenda a pelo menos um dos
                  critérios (sexo feminino OU histórico de compras recentes)
                  seria incluído na segmentação.
                </p>

                <p>
                  Veja um exemplo prático realizado pelo sistema para criar um
                  público com clientes que contém o segmento Racional, em São
                  Paulo e com Risco Financeiro Baixo:
                </p>

                <figure>
                  <img src="img/segmentacao2.png" alt="excel" />
                </figure>

                <figcaption>Perfil Risco Financeiro Baixo</figcaption>

                <p>
                  Salve a segmentação com algum nome que ajude a identificar a
                  criação deste novo público-alvo, para posteriormente
                  selecioná-lo no desenvolvimento de campanhas.
                </p>

                <p>
                  Veja um exemplo de utilização do segmento criado para
                  realização de campanhas nas redes sociais:
                </p>

                <figure>
                  <img src="img/segmentacao3.png" alt="excel" />
                </figure>

                <figcaption>Campanha com Segmentação de Contados</figcaption>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuIniciRapido />
            </div>
          </div>
        </div>

        {showScrollButton && (
          <a onClick={scrollToTop} className="btn-topo">
            <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
          </a>
        )}
      </section>
      <Footer />
    </>
  );
}
